import { ISO_NUMERIC } from "@/lib/countryColors";

export const ARAB_IDS = new Set(Object.values(ISO_NUMERIC));

export const isArab = (f) => ARAB_IDS.has(f.properties.id);

/** Bounding box of a feature in projected (SVG) coordinates, never thinner than 1px. */
export const bboxOf = (pathGen, feature) => {
  const [[x0, y0], [x1, y1]] = pathGen.bounds(feature);
  return { x: x0, y: y0, w: Math.max(1, x1 - x0), h: Math.max(1, y1 - y0) };
};

export const featureKey = (prefix, f) => `${prefix}-${f.properties.id}-${f.properties.name || ""}`;
